import { useContext } from 'react';

import {
  GiftCardsStateContext,
  GiftCardsDispatchContext,
} from 'gift-cards/providers/GiftCardsProvider';

export const useGiftCardsState = () => useContext(GiftCardsStateContext);
export const useGiftCardsDispatch = () => useContext(GiftCardsDispatchContext);
